import { render, staticRenderFns } from "./tokenCollect.vue?vue&type=template&id=0962d2e4&"
import script from "./tokenCollect.vue?vue&type=script&lang=js&"
export * from "./tokenCollect.vue?vue&type=script&lang=js&"
import style0 from "./tokenCollect.vue?vue&type=style&index=0&id=0962d2e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports